import { TPAComponentProps } from '../../types';
import { CoreLinearProgressBarProps as LinearProgressBarProps } from '../internal/WixUiCoreComponents/components/CoreLinearProgressBar';

export interface ProgressBarProps
  extends TPAComponentProps,
    Omit<LinearProgressBarProps, 'error' | 'errorIcon' | 'successIcon'> {
  /** bar thickness (small - 4px, large - 8px) */
  size?: 'small' | 'large';
}
